import {
  getStaticPathsForTopicPaginatedResultPage,
  getStaticPropsForTopicPaginatedResultPage,
  TopicPaginatedResultPage,
} from '@marketing-sites/blog-components/components/TopicPaginatedResultPage'

export const getStaticProps = getStaticPropsForTopicPaginatedResultPage
export const getStaticPaths = getStaticPathsForTopicPaginatedResultPage

export default TopicPaginatedResultPage
